export enum ROLE_SORT {
  NAME = 'name',
  TITLE = 'title',
  USERNAME = 'username',
  LAST_LOGIN_AT = 'lastLoginAt',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}
